import React from "react";
import styles from "./Screen3.module.css";
import ImageAssets from "../../../../assets";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Stack, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Screen3 = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 839px)");

  return (
    <div className={styles.container}>
      {isMobile && (
        <div className={styles.tabsContainerMobile}>
          <Stack
            columnGap={1}
            alignItems={"center"}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIosNewIcon
              sx={{
                fontSize: "26px",
                color: "var(--secondary-lite-grey-color)",
              }}
            />
          </Stack>
        </div>
      )}
      <p
        className={styles.textBig}
        style={isMobile ? null : { marginTop: "3rem" }}
      >
        How does Sekeron help artists?
      </p>
      <p className={styles.textSmall}>
        We want artists to express themselves effortlessly while exploring and
        experimenting with new ideas
      </p>

      <Segment3 text="Completely free to use" src={ImageAssets.ig_screen3_01} />
      <Segment3
        text="Collaboration made easy"
        src={ImageAssets.ig_screen3_02}
        alt
      />
      <Segment3
        text="Free tools to collaborate"
        src={ImageAssets.ig_screen3_03}
      />
      <Segment3
        text="Protect your copyright"
        src={ImageAssets.ig_screen3_04}
        alt
      />
      <Segment3 text="Showcase your talent" src={ImageAssets.ig_screen3_05} />
      <Segment3
        text="Connect with fellow artists"
        src={ImageAssets.ig_screen3_06}
        alt
      />
      <Segment3
        text="Learn and grow together"
        src={ImageAssets.ig_screen3_07}
      />
      <Segment3 text="Find what you need" src={ImageAssets.ig_screen3_08} alt />
    </div>
  );
};

const Segment3 = ({ text, src, alt = false }) => (
  <div className={`${styles.segment} ${alt ? styles.reverse : ""}`}>
    <img src={src} className={styles.image} alt="Segment" />
    <p
      className={styles.textBig}
      style={{
        fontSize: "1.8rem",
        opacity: "0.7",
        width: "50%",
        fontWeight: "normal",
      }}
    >
      {text}
    </p>
  </div>
);

export default Screen3;
